import React, { Fragment, FunctionComponent, useCallback, useState, MouseEvent } from 'react';
import ConfirmDialog from './ConfirmDialog';
import ConfirmDialogStateContext, { ConfirmDialogInfo } from './ConfirmDialogStateContext';

const confirmDialogPropsDefault: ConfirmDialogInfo = {
  title: '',
  cancelButtonText: '',
  confirmButtonText: '',
  confirmDialogChildren: undefined,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onCancel: (event) => {
    // do nothing
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onConfirm: (event) => {
    // do nothing
  },
  skippable: false,
  skipLabelText: '',
};

const ConfirmDialogProvider: FunctionComponent<React.PropsWithChildren> = ({ children }) => {
  const [confirmDialogState, setConfirmDialogState] =
    useState<ConfirmDialogInfo>(confirmDialogPropsDefault);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState<boolean>(false);

  const showConfirmDialog = useCallback((confirmDialogInfo: ConfirmDialogInfo) => {
    setConfirmDialogState(confirmDialogInfo);
    setConfirmDialogOpen(true);
  }, []);

  const onCancelWrapper = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      if (confirmDialogState.onCancel !== undefined) {
        confirmDialogState.onCancel(event);
      }
      setConfirmDialogOpen(false);
    },
    [confirmDialogState],
  );

  const onConfirmWrapper = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      if (confirmDialogState.onConfirm !== undefined) {
        confirmDialogState.onConfirm(event);
      }
      setConfirmDialogOpen(false);
    },
    [confirmDialogState],
  );

  return (
    <Fragment>
      {/* eslint-disable-next-line react/jsx-no-constructed-context-values */}
      <ConfirmDialogStateContext.Provider value={{ showConfirmDialog }}>
        {children}
      </ConfirmDialogStateContext.Provider>
      <ConfirmDialog
        open={confirmDialogOpen}
        title={confirmDialogState.title}
        cancelButtonText={confirmDialogState.cancelButtonText}
        confirmButtonText={confirmDialogState.confirmButtonText}
        onCancel={onCancelWrapper}
        onConfirm={onConfirmWrapper}
        skippable={confirmDialogState.skippable}
        skipLabelText={confirmDialogState.skipLabelText}>
        {confirmDialogState.confirmDialogChildren}
      </ConfirmDialog>
    </Fragment>
  );
};

export default ConfirmDialogProvider;
